<template>
  <section class="relative isolate overflow-hidden py-24 sm:py-32">
    <div class="mx-auto max-w-4xl px-6 lg:px-8">
      <atomic-section-heading
        align="center"
        :kicker="kicker"
        :title="title"
        :description="description"
        class="mx-auto"
      />

      <dl
        data-animate-group
        class="mt-16 space-y-4"
      >
        <Disclosure
          v-for="item in faq"
          :key="item.question"
          v-slot="{ open }"
          as="div"
          data-animate="fade-up"
          data-spotlight
          class="group relative isolate rounded-2xl bg-white ring-1 ring-gray-200 active:ring-brand-200 shadow-soft"
        >
          <shape-spotlight />

          <dt>
            <DisclosureButton class="group/toggle flex w-full items-start justify-between rounded-2xl p-6 text-left focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-brand-600">
              <span class="text-base font-semibold text-gray-900">
                {{ item.question }}
              </span>

              <span class="ml-6 flex h-7 items-center">
                <icon
                  :name="open ? 'ph:minus' : 'ph:plus'"
                  aria-hidden="true"
                  class="size-5 text-brand-600 transition group-hover/toggle:scale-110 group-active/toggle:scale-110"
                />
              </span>
            </DisclosureButton>
          </dt>

          <!-- `static` keeps the answer in the DOM: it makes the height transition possible and the text indexable -->
          <DisclosurePanel
            static
            as="dd"
            :inert="!open"
            :class="open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'"
            class="grid transition-[grid-template-rows,opacity] duration-300 ease-out motion-reduce:transition-none"
          >
            <div class="overflow-hidden">
              <p class="px-6 pb-6 pr-12 text-base/7 text-gray-600">
                {{ item.answer }}
              </p>
            </div>
          </DisclosurePanel>
        </Disclosure>
      </dl>

      <div
        data-animate="fade-up"
        class="mt-12 text-center"
      >
        <p class="text-sm text-gray-600">
          {{ footerText }}
          <button-secondary
            :link="footerLink"
            :label="footerLabel"
            icon-name="ph:arrow-right"
            class="font-semibold"
          />
        </p>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'

import type { FaqItem } from 'types/section'

type Props = {
  items?: FaqItem[],
  kicker?: string,
  title?: string,
  description?: string,
  footerText?: string,
  footerLabel?: string,
  footerLink?: string
}

const {
  items = faqHomeItems,
  kicker = 'Questions fréquentes',
  title = 'Comprendre l\'affichage dynamique',
  description = 'Les bases de l\'affichage numérique et ce que permet Live Display, pour bien démarrer.',
  footerText = 'Une autre question\u00A0?',
  footerLabel = 'Contactez-nous',
  footerLink = '/contact'
} = defineProps<Props>()

const faq = items
</script>
